// extracted by mini-css-extract-plugin
module.exports = {"empty":"Icon_empty__kDfII"};